const CHECKLIST_SECTION_COLOR_PALETTE = [
  '#2750AE',
  '#3882F0',
  '#06A09B',
  '#20D9D2',
]

export const getChecklistSectionColor = sectionIndex => {
  if (!Number.isInteger(sectionIndex) || sectionIndex < 0) {
    return null
  }

  return CHECKLIST_SECTION_COLOR_PALETTE[
    sectionIndex % CHECKLIST_SECTION_COLOR_PALETTE.length
  ]
}
